import {ref} from 'vue';
import {defineStore} from 'pinia';
import {useAsyncData, useLogger} from '#imports';
import {useFeatureFlagApi} from '../composables/useFeatureFlagApi';

export type FeatureFlags = Record<string, boolean>;

export const useFeatureFlagsStore = defineStore('nuxt-features-module-feature-flags-store', () => {
    const logger = useLogger();
    const {fetchFeatureFlags} = useFeatureFlagApi();

    const featureFlags = ref<FeatureFlags>({});

    async function init(flags: string[]) {
        const defaultStates = Object.fromEntries(flags.map((flagId) => [flagId, false]));

        if (flags.length === 0) {
            featureFlags.value = defaultStates;
            return;
        }

        const {
            data: {value: fetchedFlags},
        } = await useAsyncData('nuxt-features-module-feature-flags', async () => {
            try {
                return await fetchFeatureFlags(flags);
            } catch (error) {
                logger.error(`Error while initializing the feature flags store ["${flags.join(',')}"]. Flags state set to default (false).`, error);

                return undefined;
            }
        });

        if (!fetchedFlags) {
            featureFlags.value = defaultStates;
            return;
        }

        featureFlags.value = {...defaultStates, ...fetchedFlags.standard, ...fetchedFlags.hostBased};
    }

    return {
        init,
        featureFlags,
    };
});
